import { render, staticRenderFns } from "./SetBulkOrdersWantsAsapModal.vue?vue&type=template&id=6411d7c2"
import script from "./SetBulkOrdersWantsAsapModal.vue?vue&type=script&lang=ts"
export * from "./SetBulkOrdersWantsAsapModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports